import type { FaireProductEntity } from "../../entity_types/product";

export const p_uw4ct7ykxk: FaireProductEntity = {
  token: "p_uw4ct7ykxk",
  type: "product",
  name: "Puzzle Wood Peg Noah'S Ark",
  brandToken: "b_29xxo8ggi7",
  brandName: "Swanson Christian Products",
  imageUrl:
    "https://cdn.faire.com/fastly/c1cc88bcc052157dee8d5e4fc7962a34035356fbe40e6f5dd1bb2cadd06826c4.webp",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/bc4d968f5fb34e4927a71d49b072b279ad49874c54628aaa0e4d3abcca30fe65.webp",
    "https://cdn.faire.com/fastly/3d11468bb9fe0dadfedf96d4e7b7bbd2b3722e0034434e1c7534efb8ca0f27de.webp",
    "https://cdn.faire.com/fastly/7215a2ebb1a66bfdbcc7a3767398a1d5b1bbd6f44b945f9829927ead24bf999b.webp",
    "https://cdn.faire.com/fastly/ea44621339f72e52ef0d7634addfdc648667a2f029f2dba18f8a31eb84d9f738.webp",
    "https://cdn.faire.com/fastly/258ab226bde3742e5b4f5571aa59a92484f4ff605ee804f9d38d840b477fa36d.webp",
  ],
  priceDollars: 7.15,
  description:
    "The story of Noah's ark reminds us and our children of how faithful God is to his people! This story encourages crazy faith in God even when no one else around us believes, and this puzzle is one of the many ways to begin sharing the stories of the Bible with children. Made of smooth, sturdy wood with sanded and rounded edges, this puzzle is perfectly safe for babies, toddlers, and young children to play with. Each block features a colorful element from the beloved story of Noah's Ark, making this puzzle both educational and engaging. Your child will love matching the animals and pieces together, building their cognitive functions and improving their hand-eye coordination. Measuring 11.75\" x 8.75\" x .25\", this puzzle is the perfect size for little hands to grasp and manipulate. The pick-up pegs on each block make it easy for children to pick up and move the pieces, enhancing their fine motor skills and dexterity. Our wooden block puzzle is not only a fun toy for kids to play with but also an excellent tool for parents and educators to use in teaching young children about Noah's Ark and the importance of caring for animals. With its vibrant colors and durable construction, this puzzle is sure to provide hours of entertainment and learning for your little ones.",
  tags: [],
  msrpDollars: 12.99,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:54:45.162Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
